"use strict";

const FilterTemplate = function () {
  const render = function (filterFields, treeFilterPath, extraProps = {}) {
    if (!filterFields) {
      return "";
    }

    const filters = Tree.get(treeFilterPath);
    const filterConfig = buildFilterConfig(filterFields, filters, extraProps.searchPlaceholder);

    return nunjucks.render("filters/dynamicFilter.njk", {
      filters,
      filterConfig,
      resetButton: true,
      ...extraProps,
    });
  };

  const buildFilterConfig = function (filterFields, filters, searchPlaceholder) {
    const config = [];
    const spatialGroups = [];

    if (searchPlaceholder) {
      config.push({
        type: "text",
        spatialGroup: true,
        label: "Search",
        value: "searchString",
        placeholder: searchPlaceholder,
      });
    }

    for (const fieldKey of filterFields) {
      const field = getFieldConfig(fieldKey, filters, spatialGroups);

      if (field) {
        config.push(field);
      }
    }

    return config;
  };

  const getFieldConfig = function (fieldKey, filters, spatialGroups) {
    const fieldDef = FilterFieldConstants.getFieldDefinition(fieldKey);

    if (fieldDef.key) {
      fieldKey = fieldDef.key;
    }

    if (fieldDef.type === "multipleSelect" && !fieldDef.options?.length) {
      return null;
    }

    if (typeof fieldDef.spatialGroup === "string") {
      if (spatialGroups.length === 0) {
        spatialGroups.push(fieldDef.spatialGroup);
      } else if (!spatialGroups.includes(fieldDef.spatialGroup)) {
        return null;
      }
    }

    if (fieldDef.type === "multipleSelect") {
      return {
        key: fieldKey,
        type: fieldDef.type,
        label: fieldDef.label,
        hideIfNoDataKey: fieldDef.hideIfNoDataKey,
        spatialGroup: fieldDef.spatialGroup,
        headerGroup: fieldDef.headerGroup,
        options: fieldDef.options,
        placeholder: fieldDef.placeholder,
        allowSelectAll: fieldDef.allowSelectAll,
        highlightOnHover: fieldDef.highlightOnHover,
        allowNoSelection: fieldDef.allowNoSelection,
        selectedValue: selectedValuesToStrings(fieldDef.options, filters?.[fieldKey]),
      };
    } else if (fieldDef.type === "minMax") {
      return {
        key: fieldKey,
        type: fieldDef.type,
        label: fieldDef.label,
        displayName: fieldDef.displayName,
        hideIfNoDataKey: fieldDef.hideIfNoDataKey,
        headerGroup: fieldDef.headerGroup,
        step: fieldDef.step,
        minAttribute: fieldDef.minAttribute,
        maxAttribute: fieldDef.maxAttribute,
        selectedValue: filters?.[fieldKey],
      };
    } else if (fieldDef.type === "measurementMinMax") {
      return {
        key: fieldKey,
        type: fieldDef.type,
        label: fieldDef.label,
        displayName: fieldDef.displayName,
        hideIfNoDataKey: fieldDef.hideIfNoDataKey,
        headerGroup: fieldDef.headerGroup,
        step: fieldDef.step,
        minAttribute: fieldDef.minAttribute,
        maxAttribute: fieldDef.maxAttribute,
        unitOptions: fieldDef.unitOptions,
        selectedValue: filters?.[fieldKey],
      };
    } else if (fieldDef.type === "dateRange") {
      return {
        key: fieldKey,
        type: fieldDef.type,
        label: fieldDef.label,
        displayName: fieldDef.displayName,
        headerGroup: fieldDef.headerGroup,
        selectedValue: filters?.[fieldKey],
        noDateCheckbox: fieldDef.noDateCheckbox,
      };
    } else {
      throw new Error(`Unsupported filter field type: ${fieldDef.type}`);
    }
  };

  const selectedValuesToStrings = function (options, selectedValues) {
    if (!selectedValues) {
      return options.map((o) => o.value);
    }

    return selectedValues.map((v) => String(v));
  };

  const renderToDoSmartFilters = function (dataView, treeFilterPath) {
    const filters = Tree.get(treeFilterPath);
    const filterFields = FilterFieldConstants.getToDoFilterFields();
    const filterConfig = buildFilterConfig(filterFields, filters);

    return nunjucks.render("filters/toDoSmartFiltersContent.njk", {
      filters,
      filterConfig,
    });
  };

  return {
    render,
    renderToDoSmartFilters,
  };
};

module.exports = FilterTemplate();

const FilterFieldConstants = require("../config/filterFieldConstants");
const Tree = require("../tree");
